import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Tabs,
  Tab,
} from "@mui/material";
import {
  GlobalSearchTable,
} from "../config/grid-column-defs";
import AgGridPaginatedTable from "./AgGridPaginatedTable";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../hooks/useSnackbar";
import useErrorHandler from "../hooks/useErrorHandler";
import { useParams } from "react-router-dom";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle variant="h2" sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function SearchDataDialog({ open, id, handleClose,fetchOptions }) {
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [dialogTabIndex, setDialogTabIndex] = useState(0);
  const [messageDialogData, setMessageDialogData] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  
  

 

 
  return (
    <div className="dialogWidth">
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="dialog-box"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => {
            handleClose();
            setMessageDialogData({});
          }}
          className="closeBtn"
        >
         Global Search Results
        </BootstrapDialogTitle>

        <DialogContent dividers>
          {/* body content */}
            {/* Attachments */}
              <Box className="viewDetilsBox">
                <AgGridPaginatedTable
                  getTableRows={fetchOptions}
                  columns={GlobalSearchTable}
                  perPage={25}
                  refreshCounter={0}
                  onCellClicked={(params) => {
                    console.log("Prarams-===", params);
                    if (params.colDef.field === "tranid") {
                      handleClose();
                      
                    }
                    return;
                  }}
                />
              </Box>
            {/* Attachments */}
          
          {/* body content */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
              setMessageDialogData({});
              setDialogTabIndex(0)
            }}
            className="backBtn"
          >
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

